export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const SEARCH_DOMAIN = 'SEARCH_DOMAIN';
export const REGISTER_DOMAIN = 'REGISTER_DOMAIN';
export const TRANSFER_DOMAIN = 'TRANSFER_DOMAIN';
export const CREATE_USER = 'CREATE_USER';
